module.exports = __webpack_public_path__ + "assets/img/jthree.30021880.png";